import { Toaster } from '@invento/ui/components/toast';

/** The sole app-level transient-notification mount. */
export function ToastContainer() {
  return <Toaster />;
}
